// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantsBoard-moduleRentalPortalApplicantsBoard__SpZPt";
export { _1 as "RentalPortalApplicantsBoard" }
